import BaseClient from './client';

export const OdontogramPath = Object.freeze({
  CHART: 'doctor/odontogram',
});

const appointmentKey = (appointmentId) => {
  if (appointmentId === undefined || appointmentId === null || appointmentId === '') {
    throw new TypeError('appointmentId is required');
  }
  return appointmentId;
};

/**
 * Dental chart (odontogram) recorded per appointment. The backend scopes every
 * call to the authenticated doctor's own appointments.
 */
export class OdontogramService extends BaseClient {
  /** Returns `{ appointmentId, source: 'appointment' | 'previous' | null, chart, updatedAt }`. */
  async fetchChart(appointmentId, options = {}) {
    const response = await this.get(OdontogramPath.CHART, {
      ...options,
      params: { appointment_id: appointmentKey(appointmentId) },
    });
    return response.unwrap().data;
  }

  async saveChart(appointmentId, chart) {
    const response = await this.put(OdontogramPath.CHART, {
      appointment_id: appointmentKey(appointmentId),
      chart,
    });
    return response.unwrap().data;
  }
}

export const createOdontogramService = (baseUrl, options) => (
  new OdontogramService(baseUrl, options)
);

export const odontogramService = new OdontogramService();

export default OdontogramService;
